export function getComedianFromV2Payload(payload: unknown): {
  name: string;
  imageUrl: string;
  id: string;
  slug: string;
} {
  if (!payload || typeof payload !== "object")
    return { name: "", imageUrl: "", id: "", slug: "" };
  const p = payload as Record<string, unknown>;

  if (p.comedian && typeof p.comedian === "object") {
    const c = p.comedian as Record<string, unknown>;
    return {
      name: typeof c.display_name === "string" ? c.display_name : "",
      imageUrl: typeof c.image_url === "string" ? c.image_url : "",
      id: typeof c.id === "string" ? c.id : "",
      slug: typeof c.slug === "string" ? c.slug : "",
    };
  }

  return {
    name: typeof p.comedian_name === "string" ? p.comedian_name : "",
    imageUrl:
      typeof p.comedian_image_url === "string" ? p.comedian_image_url : "",
    id: "",
    slug: typeof p.comedian_slug === "string" ? p.comedian_slug : "",
  };
}
